import { useTranslation } from "react-i18next";
import { useJoinRoom } from "../../domains/room/hooks/useJoinRoom";

/**
 * Follow, on a room line of a desktop list (the Explore rail, the rooms
 * directory).
 */
function DesktopFollowRoomButton({
  roomId,
}: {
  roomId: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const { joinRoom, isJoining } = useJoinRoom(roomId, "public app", "greet");
  return (
    <button
      type="button"
      disabled={isJoining}
      onClick={() => {
        void joinRoom();
      }}
      className="shrink-0 cursor-pointer rounded-lg bg-ds-primary px-2.5 py-1.25 text-footnote font-semibold text-ds-white disabled:cursor-not-allowed disabled:bg-ds-disabled-bg disabled:text-ds-disabled-text"
    >
      {t("Follow")}
    </button>
  );
}

export { DesktopFollowRoomButton };
